import { PERMISSIONS } from '@/constants/permissions.constant';
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { OrderService } from '@/services';

const Authentication = namespace('authentication');
@Component
export default class CustomSidebar extends Vue {

    @Authentication.Getter('hasPermission') private hasPermission: (permission: string) => boolean;

    public sortedMenuItems: any[] = [];
    public menuItems: any[] = [
        {
            path: { name: 'userList' },
            title: 'modules.userManagement.plural',
            permission: PERMISSIONS.User.READ,
        },
        {
            path: { name: 'businessList' },
            title: 'modules.businessManagement.plural',
            permission: PERMISSIONS.Business.READ,
        },
    ];

    // TODO: move to shop order view if its fully implemented.
    public async getExport() {
        const response = await OrderService.exportData();
        console.log('response', response);
    }

    public beforeMount() {

        this.sortedMenuItems = this.menuItems.filter((menuItem) => {
            return this.hasPermission(menuItem.permission);
        });

    }

}
